module.exports = __webpack_public_path__ + "static/media/NimbusSanL-Reg.1e0c37f0.woff";